<div class="card p-3">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="mb-0">Trips Analytics</h5>

    <div>
      <button
        class="btn btn-sm btn-outline-primary me-2"
        [class.active]="frequency === 7"
        (click)="changeFrequency(7)"
      >
        Last 7 Days
      </button>

      <button
        class="btn btn-sm btn-outline-primary"
        [class.active]="frequency === 30"
        (click)="changeFrequency(30)"
      >
        Last 30 Days
      </button>
    </div>
  </div>

  <canvas
    baseChart
    [datasets]="chartData"
    [labels]="chartLabels"
    [options]="chartOptions"
    [chartType]="chartType"
  >
  </canvas>
</div>
